module.exports = __webpack_public_path__ + "static/b1-eb78a54723d916aeb18f97a69982e37f.jpg";